import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent
} from "@angular/common/http";
import { catchError, switchMap } from "rxjs/operators";
import { from, Observable, throwError } from "rxjs";
import { PartnerService } from "./partner.service";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private partnerService: PartnerService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Skip adding partnerCode for the GetPartnerDetailByCode endpoint
    if (req.url.includes("GetPartnerDetailByCode")) {
      return next.handle(req);
    }

    // [iOS WebKit] Service Worker fetch passthrough can drop the body of
    // multipart requests. Bypass ngsw entirely for FormData submissions.
    if (req.body instanceof FormData) {
      req = req.clone({ params: req.params.set("ngsw-bypass", "true") });
    }

    return from(this.partnerService.getPartnerCode()).pipe(
      switchMap((partnerCode) => {
        if (partnerCode) {
          req = req.clone({ setHeaders: { partnerCode } });
        }
        return next.handle(req);
      }),
      catchError((err) => {
        console.error(err);
        if (err.status === 401) {
          err.error = "Session expired";
        } else if (err.status === 0) {
          err.error = "Unable to connect to server.";
        }
        return throwError(() => err);
      })
    );
  }
}
